import { Component } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import GroupDetails from 'part11/components/GroupDetails/GroupDetails';
import GroupUsers from 'part11/components/GroupUsers/GroupUsers';
import styles from '../Group.scss';
import icons from 'styles/icons/icons.scss';

import {
    initializeGroupScene,
    clearGroupsScene,
    addUserToGroup,
    removeUserFromGroup,
} from 'part11/actions/groups';


const Header = ({ group }) => {
    if (group) {
        return (
            <header className={styles.header} data-cy="Group">
                <div className={styles.icon}>
                    <span className={icons.materialIcons}>people_outline</span>
                </div>
                <span className={styles.title} data-cy="Group-displayName">{ group.displayName }</span>
            </header>
        );
    }
};

export class Group extends Component {

    constructor(props) {
        super(props);
    }

    loadData() {
        const { institutionId, groupId } = this.props;

        this.props.initializeGroupScene(groupId, institutionId);
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillUnmount() {
        this.props.clearGroupsScene();
    }

    render() {
        const {
            group, availableUsers, addUserToGroup, removeUserFromGroup, institutionId, location
        } = this.props;

        return (
            <div className={styles.container} data-cy="Group-return">
                <Header group={group} />
                <div className={styles.groupInfo} data-cy="Group-groupInfo">
                    <GroupDetails
                        group={group}
                        institutionId={institutionId} />
                    <GroupUsers
                        group={group}
                        institutionId={institutionId}
                        location={location}
                        availableUsers={lodash.values(availableUsers)}
                        addUserToGroup={addUserToGroup}
                        removeUserFromGroup={removeUserFromGroup} />
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {
    const group = lodash.get(state, 'scene.group', {});
    const availableUsers = lodash.get(state, 'scene.availableUsers', {});
    const institutionId = props.params.id || state.me.institution.id;
    const groupId = props.params.groupId;
    return{
        group,
        availableUsers,
        institutionId,
        groupId
    };
}, {
    initializeGroupScene,
    addUserToGroup,
    clearGroupsScene,
    removeUserFromGroup
})(Group);
